import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'

import type { DropdownDependency, DropdownOption } from '../../dropdown/types/dropdown.types'

type DeleteOptionDialogProps = {
  deps: DropdownDependency[] | null
  item: DropdownOption | null
  open: boolean
  onClose: () => void
  onConfirmDelete: () => void
  onDeactivateInstead: () => void
}

export function DeleteOptionDialog({
  deps,
  item,
  open,
  onClose,
  onConfirmDelete,
  onDeactivateInstead,
}: DeleteOptionDialogProps) {
  const hasDependencies = deps?.some(dependency => dependency.count > 0)

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Delete Option</DialogTitle>
      <DialogContent>
        {hasDependencies ? (
          <Box>
            <Alert severity="warning" sx={{ mb: 2 }}>
              This option is used by existing technote records. Deactivate instead of deleting to preserve historical data.
            </Alert>
            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Dependency</TableCell>
                    <TableCell>Count</TableCell>
                    <TableCell>Impact</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {deps?.map((dependency, index) => (
                    <TableRow key={index}>
                      <TableCell>{dependency.label}</TableCell>
                      <TableCell>{dependency.count}</TableCell>
                      <TableCell sx={{ fontSize: 12, color: '#667085' }}>{dependency.impact}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        ) : (
          <Typography>
            Are you sure you want to permanently delete <strong>{item?.display_value}</strong>?
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        {!hasDependencies && (
          <Button variant="contained" color="error" onClick={onConfirmDelete}>
            Delete Permanently
          </Button>
        )}
        <Button variant="outlined" color="warning" onClick={onDeactivateInstead}>
          Deactivate Instead
        </Button>
      </DialogActions>
    </Dialog>
  )
}
